import { Injectable } from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {LoginRequest} from '../models/requests/login-request';
import {environment} from '../../../environments/environment';
import {TokenResponse} from '../models/responses/token-response';
import {Observable} from 'rxjs';
import {User} from '../models/entities/user';
import {RegisterUserRequest} from '../models/requests/register-user-request';
import {RegistrationResponse} from '../models/responses/registration-response';
import {HeaderComponent} from '../../modules/system/parts/header/header.component';
import {Role} from '../models/entities/role';
import {Org} from '../models/entities/org';
import {UserChangePasswordRequest} from '../models/requests/user-change-password-request';
import {UserChangePasswordResponse} from '../models/responses/user-change-password-response';
import {Router} from '@angular/router';
import {UserRequest} from '../models/requests/user-request';

// @ts-ignore
@Injectable({
  providedIn: 'root'
})
export class AuthService {

  private apiUrl = environment.apiUrl;
  public isAdmin = false;
  // public userOrgCode;
  // adminUsers: string[] = ['dasha', 'admin', 'admin1', 'mira', 'user5'];

  constructor(private http: HttpClient,
              private router: Router) {
  }

  public login(request: LoginRequest): Observable<TokenResponse> {
    return this.http.post<TokenResponse>(`${this.apiUrl}/login`, request);
  }

  public register(request: RegisterUserRequest): Observable<RegistrationResponse>{
    return this.http.post<RegistrationResponse>(`${this.apiUrl}/api/users`, request);
  }

  /*public register(request: RegisterUserRequest): Observable<any>{
    return this.http.post<any>(`${this.apiUrl}/api/users`, request);
  }*/

  public authorize(token: string) {
    localStorage.setItem('token', token);
  }

  public clearAll() {
    localStorage.removeItem('token');
    localStorage.removeItem('codeQR');
    localStorage.removeItem('currentUser');
    localStorage.removeItem('role');
  }

  public logout() {
    this.clearAll();
    this.router.navigateByUrl('/auth');
  }

  public checkAuthorized(): boolean {
    return !!localStorage.getItem('token');
  }

  public getToken(): string {
    return localStorage.getItem('token');
  }

  public setCodeQR(codeQR: string) {
    localStorage.setItem('codeQR', codeQR);
  }

  public getCodeQR(): string {
    return localStorage.getItem('codeQR');
  }

  public getOrgCodes(): Observable<string[]> {
    return this.http.get<string[]>(`${this.apiUrl}/api/users/orgs`);
  }

  public setCurrentUser(username: string) {
    localStorage.setItem('currentUser', username);
  }

  public getCurrentUser(): string {
    return localStorage.getItem('currentUser');
  }

  public setCurrentRoles(roles: Role[]) {
    // localStorage.setItem('role', role.name);
    localStorage.setItem('roles', JSON.stringify(roles));
  }

  /*public getCurrentRole(): string {
    return localStorage.getItem('role');
  }*/

  public getCurrentRoles(): Role[] {
    return JSON.parse(localStorage.getItem('roles'));
  }

  checkAdmin() {
    // tslint:disable-next-line:triple-equals
    /*if (this.getCurrentRoles() == 'ROLE_ADMIN') {
      return true;
    }*/
    return this.getCurrentRoles().filter(x => x.name === 'ROLE_ADMIN').length > 0;
  }

  checkManagerRP() {
    // tslint:disable-next-line:triple-equals
    /*--tmp if (this.getCurrentRole() == 'ROLE_MANAGER_RP') {
      return true;
    }*/
    return this.getCurrentRoles().filter(x => x.name === 'ROLE_MANAGER_RP').length > 0;
  }

  checkManagerDT() {
    // tslint:disable-next-line:triple-equals
    /* -- tmp if (this.getCurrentRole() == 'ROLE_MANAGER_DT') {
      return true;
    }*/
    return this.getCurrentRoles().filter(x => x.name === 'ROLE_MANAGER_DT').length > 0;
  }

  checkUserStock() {
    // tslint:disable-next-line:triple-equals
    /*--tmp if (this.getCurrentRole() == 'ROLE_USER_STOCK') {
      return true;
    }*/
    return this.getCurrentRoles().filter(x => x.name === 'ROLE_USER_STOCK').length > 0;
  }

  checkUserCurr() {
    // tslint:disable-next-line:triple-equals
    /* --tmp if (this.getCurrentRole() == 'ROLE_USER_CURRENCY') {
      return true;
    }*/
    return this.getCurrentRoles().filter(x => x.name === 'ROLE_USER_CURRENCY').length > 0;
  }

  checkUserDeriv() {
    // tslint:disable-next-line:triple-equals
    /*if (this.getCurrentRole() == 'ROLE_USER_DERIV') {
      return true;
    }*/
    return this.getCurrentRoles().filter(x => x.name === 'ROLE_USER_DERIV').length > 0;
  }

  checkUserRegulator() {
    // tslint:disable-next-line:triple-equals
    // return this.getCurrentRole() == 'ROLE_USER_REGULATOR';
    return this.getCurrentRoles().filter(x => x.name === 'ROLE_USER_REGULATOR').length > 0;
  }

  checkUserIPO() {
    // tslint:disable-next-line:triple-equals
    // this.getCurrentRole() == 'ROLE_USER_IPO';
    return this.getCurrentRoles().filter(x => x.name === 'ROLE_USER_IPO').length > 0;
  }

  checkUserAccount() {
    // tslint:disable-next-line:triple-equals
    // this.getCurrentRole() == 'ROLE_USER_ACCOUNT';
    return this.getCurrentRoles().filter(x => x.name === 'ROLE_USER_ACCOUNT').length > 0;
  }

  checkUserFxClientCode() {
    return this.getCurrentRoles().filter(x => x.name === 'ROLE_USER_FX_CLIENTCODE').length > 0;
  }

  checkUserSinglePool() {
    // tslint:disable-next-line:triple-equals
    // this.getCurrentRole() == 'ROLE_USER_SINGLEPOOL';
    return this.getCurrentRoles().filter(x => x.name === 'ROLE_USER_SINGLEPOOL').length > 0;
  }

  public getRoles(): Observable<string[]> {
    return this.http.get<string[]>(`${this.apiUrl}/api/users/roles`);
  }

  public getRoleByUsername(username: string): Observable<Role[]> {
    return this.http.get<Role[]>(`${this.apiUrl}/api/users/roles/${username}`);
  }

  public getCurrencies(): Observable<string[]> {
    return this.http.get<string[]>(`${this.apiUrl}/api/users/currencies`);
  }

  public changePassword(request: UserChangePasswordRequest): Observable<UserChangePasswordResponse>{
    return this.http.put<UserChangePasswordResponse>(`${this.apiUrl}/api/users/pwdchange`, request);
  }
}
